import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useT } from "@/lib/i18n";
import { ATLAS } from "@/constants/testIds";
import { Search, MapPin } from "lucide-react";

export default function Appellations() {
  const { t } = useT();
  const [items, setItems] = useState([]);
  const [q, setQ] = useState("");

  useEffect(() => {
    api.get("/appellations")
      .then((r) => setItems(Array.isArray(r.data) ? r.data : []))
      .catch(() => setItems([]));
  }, []);

  const filtered = (Array.isArray(items) ? items : []).filter((a) =>
    [a.name, a.region, a.country, a.type].join(" ").toLowerCase().includes(q.toLowerCase())
  );

  return (
    <div className="max-w-6xl mx-auto px-5 md:px-10 py-12 md:py-16">
      <span className="chip-pink">{t("app.kicker")}</span>
      <h1 className="font-display text-4xl md:text-5xl tracking-tight text-[#1F3A5F] mt-4 font-medium">{t("app.title")}</h1>
      <p className="text-[#4A5568] mt-3 max-w-2xl">{t("app.subtitle")}</p>

      <div className="mt-8 max-w-md flex items-center gap-2 bg-white border border-[#1F3A5F]/15 focus-within:border-[#E5276A] rounded-xl px-4 py-3 shadow-sm">
        <Search className="w-4 h-4 text-[#8B95A1]" />
        <input data-testid={ATLAS.search} value={q} onChange={(e) => setQ(e.target.value)} placeholder={t("app.search")}
          className="flex-1 bg-transparent outline-none text-sm text-[#1F3A5F] placeholder:text-[#8B95A1]" />
      </div>

      <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {filtered.map((a) => (
          <Link key={a.slug} to={`/appellations/${a.slug}`} data-testid={ATLAS.card(a.slug)} className="app-card overflow-hidden group">
            <div className="aspect-[5/3] relative bg-gradient-to-br from-[#FBF7F3] via-[#FCE4ED]/40 to-[#FBF7F3] flex items-center justify-center overflow-hidden">
              <div className="absolute top-3 left-3 px-2 py-1 rounded text-[10px] uppercase tracking-widest bg-white/95 backdrop-blur text-[#E5276A] font-bold">
                {a.type}
              </div>
              <div className="font-display text-5xl md:text-6xl text-[#1F3A5F]/15 group-hover:text-[#E5276A]/30 transition-colors duration-500 tracking-tighter">
                {a.name?.[0] || "A"}
              </div>
              <div className="absolute bottom-2 right-3 text-[10px] uppercase tracking-widest text-[#1F3A5F]/40 font-bold">{a.country}</div>
            </div>
            <div className="p-5">
              <div className="font-display text-xl text-[#1F3A5F] font-medium">{a.name}</div>
              <div className="text-sm text-[#8B95A1] mt-1 inline-flex items-center gap-1.5">
                <MapPin className="w-3.5 h-3.5 text-[#E5276A]" /> {a.region}, {a.country}
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
